module.exports = __webpack_public_path__ + "static/media/screenshot_challenging_endless_runner.c3388d04.png";